import LearningConfigAPI from '@/apis/business/student/learning-config-api.js'

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    /**
     * lấy ra tất cả phòng học theo User
     * @param {*} context
     * @returns
     * @author VDDung1
     */
    async getLearningConfigByUser (context, param) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.getAsync('learning-config', { params: param })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
